import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { usePlanStore } from '@/store/PlanStore'
import { useCouponStore } from '@/store/CouponStore'
import { useSubscriptionStore } from '@/store/SubscriptionStore'

export const useTrialStatus = () => {
  const planStore = usePlanStore()
  const couponStore = useCouponStore()
  const subscriptionStore = useSubscriptionStore()

  const { selectedPlanTrialLength } = storeToRefs(planStore)
  const { isFreeTrialCoupon } = storeToRefs(couponStore)
  const { isEligibleForTrial } = storeToRefs(subscriptionStore)

  const planHasTrial = computed(() => isFreeTrialCoupon.value || (selectedPlanTrialLength.value > 0 && isEligibleForTrial.value))

  return { planHasTrial }
}
